const LANGUAGE = {
  erroGeral: 'Ocorreu um erro, tente novamente!',
  titleVideos: 'Vídeos',
  titleCadastroVideos: 'Cadastro de vídeo',
  fieldNome: 'Nome',
  fieldDigiteNome: 'Digite o nome',
  fieldVideoMasculino: 'Vídeo masculino',
  fieldVideoFeminino: 'Vídeo feminino',
  observacoes: 'Observações',
  salvar: 'Salvar',
  msgCamposObrigatoriosVideos: 'Preencha o nome do vídeo e adicione ao menos um vídeo',
  salvoSucesso: 'Item salvo com sucesso',
  atencao: 'Atenção',
  msgRemover: 'Tem certeza que deseja remover o item selecionado?',
  remover: 'Remover',
  fechar: 'Fechar',
  itemRemovidoSucesso: 'Item removido com sucesso',
  titleBlocos: 'Blocos diários',
  cadastroBloco: 'Cadastro de bloco diário',
  nomeBloco: 'Nome do bloco',
  digiteAqui: 'Digite aqui',
  sexo: 'Sexo',
  erroSalvarBloco: 'Ocorreu um erro ao salvar o bloco',
  emailCadastrado: 'Email já cadastrado!',
  cpfCadastrado: 'Cpf já cadastrado!',
  cpfEmailCadastrado: 'Cpf e E-mail já cadastrados!',
  preenchaCamposAsterisco: 'Preencha todos os campos com um asterisco',
  impossivelRemoverItem: 'Impossível remover o item',
  escolhaOsExercicios: 'Escolha os exercícios',
  erroSalvar: 'Ocorreu um erro ao salvar o item',
  erroRemover: 'Ocorreu um erro ao remover o item',
  erroDetalhe: 'Ocorreu um erro ao retornar os dados do item escolhido',
  masculino: 'Masculino',
  feminino: 'Feminino',
  titleBlocosPlanilha: 'Blocos semanais',
  copiarBlocoPlanilha: "Copiar bloco semanal",
  quantidadeDias : 'Quantidade de dias',
  adicionarBloco : 'Adicionar bloco',
  escolhaQntDias: 'Selecione a quantidade de dias da planilha',
  adicioneBlocos: 'Adicione blocos de exercícios a sua Planilha',
  qntBlocosMenorQueQntDias: 'A quantidade de blocos de exercícios deve ser igual a quantidade de dias',
  erroBlocoPlanilha: 'Ocorreu um erro ao gerar os dados do formulário',
  errorSaveBlocoPlanilha: 'Ocorreu um erro ao salvar o bloco de planilha',
  titlePlanilhasTreino: '20 modelos',
  cadastroPlanilha: 'Cadastro de 20 modelos',
  nome_planilha: 'Nome da Planilha',
  dataInicio: 'Data de início',
  dataFim: 'Data fim',
  copiarPlanilha: 'Copiar 20 modelos',
  carregandoPlanilha: "Carregando planilha, aguarde um instante!",
  criandoPlanilha: "Criando planilha, aguarde um instante!",
  digiteNomePlanilha: "Digite o nome da Planilha",
  erroDataPlanilha: 'As datas inicial e final devem ter 6 dias de diferença para completar uma semana de treino',
  erroDataSexoPlanilha: 'Ocorreu um erro ao gerar a planilha, tente novamente (1002x10)',
  msgQntPlanilhasMenorQue5: 'A quantidade de planilhas (hipertrofia e emagrecimento) femininas e masculinas deve ser 5 (2, 3, 4, 5 e 6 dias)! Selecione no select "Adicionar bloco de planilha" os 5 dias relacionados a cada planilha',
  algumaPlanilhaNaoTemExercico: 'Alguma das planilhas adicionadas não possui exercícios cadastrados. É necessário que cadastre ao enos um exercício na planilha.',
  verifiquePlanilhas: 'Verifique suas planilhas pois alguma delas tem a quantidade de blocos menor que a quantidade de dias. Por exemplo, se a quantidade de dias  é 2, o bloco de planilha deverá ter exatamente dois blocos.',
  errorSavePlanilha: 'ocorreu um erro ao salvar a planilha de treino',
  titleExercicios: 'Exercícios',
  imagemFeminina: 'Imagem feminina',
  imagemMasculina: 'Imagem masculina',
  selecioneVideo: 'Selecione o vídeo',
  cadastroExercicio: 'Cadastro de exercício',
  planosAlimentares: 'Planos alimentares',
  titulo: 'Título',
  cadastroPlanoAlimentar: 'Cadastro de plano alimentar',
  imagem: 'Imagem',
  linkYoutube: 'Link do youtube',
  planoMasculino: 'Plano masculino',
  planoFeminino: 'Plano feminino',
  ativar: 'Ativar',
  usuarioSenha: 'Digite o usuário e a senha',
  erroLogar: 'Ocorreu um erro ao se logar',
  selecioneExercicios: 'Selecione os exercícios',
  cadenciaTitle: 'Cadência',
  seriesRepeticoes: 'Séries/repetições',
  intervaloTitle: 'Intervalo',
  diaSemanaTitle: 'Dia da semana',
  nenhumItem: 'Nenhum item',
  exerciciosJaAdiconado: 'O exercício já foi adicionado!',
  adiconarBlocoPlanilha: 'Adicionar bloco de planilha (2,3,4,5 e 6 dias)',
  tipoDePlanilha: 'Tipo de planilha',
  impossivelRemover: 'Impossível remover o item selecionado',
  nomePlano: 'Nome do plano',
  periodicidade: 'Periodicidade',
  descricaoPlano: 'Descrição do plano',
  valorPlano: 'Valor (se for vazio é grátis)',
  relatorios: 'Relatórios',
  treinoDomiciliar: 'Treino domiciliar',
  nomeTreinoDomiciliar: 'Nome do treino',
  titlePlanos: 'Planos',
  erroLoad: 'Ocorreu um erro ao carregar os dados da página',
  titleSobre: 'Sobre',
  titleTermos: 'Termos de uso',
  titleEbook: 'E-book',
  titlePerguntas: 'Perguntas frequentes',
  txtPergunta: 'Pergunta',
  txtResposta: 'Resposta',
  cadastroPergunta: 'Cadastro de pergunta',
  preenchaTodosCampos: 'Preencha todos os campos',
  titleUsuarios: 'Usuários',
  titleNewMessage: 'Nova mensagem',
  enviar: 'Enviar',
  assuntoTitle: 'Assunto',
  titleMensagem: 'Mensagem',
  titleMensagens: 'Mensagens',
  fieldPeso: 'Meu peso (kg)',
  fieldGordura: 'Gordura corporal (%)',
  fieldAltura: 'Minha altura (cm)',
  fieldBicepsDireito: 'Bíceps direito (cm)',
  fieldBicepsEsquerdo: 'Bíceps esquerdo (cm)',
  fieldQuadril: 'Quadril (cm)',
  fieldAbdomen: 'Abdomen (cm)',
  fieldCintura: 'Cintura (cm)',
  fieldTorax: 'Tórax (cm)',
  fieldPanturrilhaEsquerda: 'Panturrilha esquerda (cm)',
  fieldPanturrilhaDireita: 'Paturrilha direita (cm)',
  fieldCoxaEsquerda: 'Coxa esquerda (cm)',
  fieldCoxaDireita: 'Coxa direita (cm)',
  fieldAnterabracoEsq: 'Antebraço esquerdo (cm)',
  fieldAntebracoDireito: 'Antebraço direito (cm)',
  txtData: 'Data',
  txtNome: 'Nome',
  txtEmailCadastro: 'E-mail',
  txtTipoTreino: 'O que procura?',
  txtOndeTreina: 'Onde irá treinar?',
  txtQuantidadeDias: 'Quantos dias por semana irá treinar?',
  txtTempoMusculacao: 'Já faz musculação há quanto tempo?',
  txtSalvar: 'Salvar',
  txtCpf: 'Cpf',
  txtDataNasc: 'Data de nascimento',
  txtTel: 'Telefone celular',
  txtSenha: 'Senha',
  txtConfirmarSenha: 'Confirmar senha',
  txtSenhaAntiga: 'Senha antiga',
  txtEstado: 'Estado',
  escolhaEstado: 'Escolha o estado',
  txtCidade: 'Cidade',
  digiteCidade: 'Digite a cidade',
  txtBairro: 'Bairro',
  digiteBairro: 'Digite o bairro',
  txtLogradouro: 'Logradouro',
  digiteLogradouro: 'Digite o logradouro',
  txtComplemento: 'Complemento',
  digiteComplemento: 'Digite o complemento',
  txtNumero: 'Nº',
  digiteNumero: 'Digite o nº',
  txtCep: 'Cep',
  digiteCep: 'Digite o cep',
  txtCadencia: 'Cadência',
  txtIntervalo: 'Intervalo',
  txtRepeticoes: 'Repetições',
  titleTreino: 'Treino',
  problemasSaude: 'Possui algum desses problemas de saúde?',
  cardiaco: 'Problemas cardíacos',
  renais: 'Problemas renais',
  diabetes: 'Diabetes',
  ombros: 'Dor nos ombros',
  coluna: 'Dor na coluna',
  joelhos: 'Dor nos joelhos',
  outrosProblemas: 'Caso tenha outros problemas de saúde, por favor informe logo abaixo:',
  digiteProblema: 'Digite o problema de saúde',
  obsProblema: 'Obs: Adicione um de cada vez',
  manNotAllowd: 'O Foco90 ainda não possui treinos específicos para homens. Estamos trabalhando arduamente para que os homens também possam fazer parte do Foco90. Em breve teremos novidades!',
  txtSessoes: 'Sessões',
  txtRepeticoes: 'Repetições',
  txtCircuito: 'Circuito',
  btObjetivo: 'Não sabe como escolher seu objetivo? Clique aqui',
  nenhumProblema: 'Não possuo limitação',
  senhasErradas: 'As senhas não conferem',
  erroRecuperacaoSenha: 'Ocorreu um erro ao mudar a senha',
  politicaPrivacidade: 'Política de privacidade',
  titleEsqueceuSenha: 'Recuperar senha',
  digiteEmail: 'Digite o e-mail',
  msgEsqueceuSenha: 'Infrome seu e-mail que lhe enviaremos instruções para você alterar sua senha',
  escolhaPlano: 'Escolha o plano',
  txtNomeCartao: 'Nome como no cartão',
  digiteNomeCartao: "Digite o nome",
  txtNumeroCartao: 'Nº do cartão',
  digiteNCartao: 'Digite o nº',
  txtDataExpiracao: 'Data de expiração',
  digiteData: 'Digite a data',
  cvc: 'CVV',
  digiteCVC: 'Digite aqui',
  txtparcelas: 'Nº de parcelas',
  txtCartao: 'Selecione a bandeira',
  preenchaBandeira: 'Selecione a bandeira',
  preenchaParcelas: 'Escolha as parcelas',
  todoscamposObrigatorios: 'Todos os campos são obrigatórios',
  erroValidate: 'Ocorreu um erro, tente novamente (1002)',

  intro1: 'Olá! Aqui é Roberto Jacob. Seja muito bem-vinda ao app Foco 90!! Vamos começar as mudanças efetivas no seu corpo!',
  intro2: 'Aqui vão algumas informações importantes.',
  intro3: 'Primeiramente, NÃO COMECE A TREINAR sem ver os vídeos e textos sobre as TÉCNICAS do seu treino, senão você não entenderá o método corretamente para ter resultados, pois o Foco90 não são só planilhas de treino, mas um método desenvolvido juntando muita ciência e mais de 20 anos de experiência no salão de musculação em academias. Essas explicações e vídeos estão disponíveis para você no Menu, em “Técnicas” para quando você desejar acessar. Novos vídeos podem ser adicionados a qualquer momento, sempre visando atender melhor você.',
  /*intro4: 'À direita você tem um MENU, pelo qual você vai se guiar para navegar pelo app.',*/
  intro5: 'Você sempre terá um treino diferente por semana! As planilhas estarão disponíveis semanalmente para você no app, e serão trocadas aos domingos, para que uma nova semana de treinos se inicie na segunda-feira. Abaixo de cada exercício do dia terá o vídeo da execução. Fique atenta(o) às observações que podem aparecer logo abaixo dos vídeos. Elas serão importantes para seu treino.',
  intro6: 'Qualquer questão de suporte, fale com a gente no campo “Mensagem” (menu à esquerda).',
  intro7: 'Então vamos em busca do seu melhor resultado!',
  intro8: 'Abraço, Roberto Jacob',
  intro9: 'Essas explicações e vídeos estão disponíveis para você no Menu, em “Técnicas” para quando você desejar acessar. Novos vídeos podem ser adicionados a qualquer momento, sempre visando atender melhor você.',
  txtContinuar: 'Continuar',
  digiteUsuario: 'Digite o usuário',
  digiteCpf: 'Digite o CPF',
  digiteSenha: 'Digite a senha',
  dadosAcesso: 'Dados de acesso',
  meuTreino: 'Meu treino',
  erroPlanos: 'Ocorreu um erro ao carregar os planos, tente novamente.',
  ErroPagseguro: 'Ocorreu um erro ao carregar os dados do pagamento, por favor, feche e abra o aplicativo novamente',
  treinoCasaTxt: 'Treinos em casa são apenas para emagrecimento!',
  msgGrupoFB: 'O bônus do grupo exclusivo só é válido após contratação de um de nossos pacotes.',
  hello: 'Olá',
  queroParticipar: 'Quero participar',
  fb1: 'Para participar do grupo fechado, clique no botão logo abaixo e solicite sua participação.',
  fb2: 'MAS ATENÇÃO! VOCÊ PRECISA ENVIAR UM EMAIL PARA contato@foco90.com.br INFORMANDO EXATAMENTE COMO ESTÁ SEU NOME NO FACEBOOK, O EMAIL QUE FEZ A COMPRA E O SEU CPF, para que possamos aceitar sua solicitação.',
  fb3: 'Pode demorar de 24h a 72h para que você seja incluída, devido à grande demanda.',
  fb4: 'Agradecemos a compreensão.',
  fb5: 'Equipe Foco90',
  fb6: 'Para participar do Grupo Exclusivo de alunas do Foco90, digite seu nome como está no Facebook, clique no botão abaixo e aguarde o prazo de liberação.',
  btConhecaPlanos: 'Conheça os planos',
  txtCarga:'Digite a carga',
  txtAddCarga: 'Adicionar carga',
  preenchaCarga: 'Preencha a carga',
  nomeFbGroup: 'Digite seu nome como está no Facebook',
  txtNomeFbUser: 'Digite aqui',
  txtSendByMail: 'Enviar por email',
  erroTreino: 'Ocorreu um erro ao enviar o treino para seu e-mail',
  sucessTreino: 'O treino foi enviado para seu e-mail'
};

export default LANGUAGE;



// WEBPACK FOOTER //
// ./src/data/language/pt_br/language.js